{{#if this.item.isUser}}
  {{avatar this.item imageSize="tiny"}}
  <div>
    <span class="identifier">{{format-username this.item.id}}</span>
    <span class="name">{{this.item.name}}</span>
  </div>
  {{#if (and this.item.showUserStatus this.item.status)}}
    <UserStatusMessage @status={{this.item.status}} @showDescription={{true}} />
  {{/if}}
  {{decorate-username-selector this.item.id}}
{{else if this.item.isGroup}}
  {{d-icon "users"}}
  <div>
    <span class="identifier">{{this.item.id}}</span>
    <span class="name">{{this.item.full_name}}</span>
  </div>
{{else}}
  {{d-icon "envelope"}}
  <span class="identifier">{{this.item.id}}</span>
{{/if}}